<template>
  <div>
    <div class="category-title">
      <h1 class="h1-like">
        {{ $t("dashboard.org_external_donors", "External Donors") }}
      </h1>

      <div class="action-block">
        <div class="item">
          <b-button class="bttn bttn--lg bttn--orange" @click="openImportModal">
            {{ $t("dashboard.import_org_external_donors", "Import External Donors") }}
          </b-button>
        </div>
      </div>
    </div>

    <OrgExternalDonorsTable ref="orgExternalDonorsTable" />

    <OrgExternalDonorsImportModal
      ref="importModal"
      :orgCustomerID="orgCustomerID"
      @imported="refresh"
    />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import OrgExternalDonorsImportModal from "./OrgExternalDonorsImportModal.vue";
import OrgExternalDonorsTable from "./OrgExternalDonorsTable.vue";

export default defineComponent({
  components: {
    OrgExternalDonorsTable,
    OrgExternalDonorsImportModal,
  },
  computed: {
    orgCustomerID() {
      return localStorage.getItem("orgId");
    },
  },
  methods: {
    refresh() {
      this.$refs.orgExternalDonorsTable.refresh();
    },
    openImportModal() {
      this.$refs.importModal.open();
    },
  },
});
</script>

<style lang="scss" scoped></style>
